import React, { Component } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  Grid,
  Dialog,
  DialogContent,
  IconButton,
  TextField, Tooltip
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import CloseIcon from '@material-ui/icons/Close'
import { USER_INFO } from '__helpers/constants';
import { PATIENT_LIST, MULTIPLE_PATIENT_LIST } from '__helpers/constants';
import PatientTasks from './PatientTasks';
// ✅ Removed unused Material-UI icons (replaced with custom SVGs)
// import LocalPharmacyIcon from '@material-ui/icons/LocalPharmacy';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects'
import PatientNotesRiskClass from './PatientNotesRiskSummary';
import { userService } from '_services/user.service';
import { generalAuthTokenHeader } from '__helpers/auth-header';
import { apiPath } from 'api';
import Low from '../../../assets/img/LOW.png'
import Medium from '../../../assets/img/MEDIUM.png'
import High from '../../../assets/img/HIGH.png'
import Summary from '../../../assets/img/risk_summary/Summary.png';
import Detailed from '../../../assets/img/risk_summary/Detailed.png';
import Justification from '../../../assets/img/risk_summary/Justification.png';
import Suggestions from '../../../assets/img/risk_summary/Suggestions.png';
import confusion from '../../../assets/img/risk_summary/confusion.png';
import Functional from '../../../assets/img/risk_summary/Functional.png';
import PainDiscomfort from '../../../assets/img/risk_summary/PainDiscomfort.png';
import MedicationAdherence from '../../../assets/img/risk_summary/MedicationAdherence.png';
import Social from '../../../assets/img/risk_summary/Social.jpg';
import { Close, Edit, Save } from '@material-ui/icons';
import riskIcon from '../../../assets/img/risk.svg';
import DateFnsUtils from '@date-io/date-fns';

// ✅ Import domain icons from Risk Summary folder
import MedsIcon from '../../../assets/img/icons/Risk Summary/Meds.svg';
import SocialSupportIcon from '../../../assets/img/icons/Risk Summary/SocialSupport.svg';
import CognitionIcon from '../../../assets/img/icons/Risk Summary/Cognition.svg';
import FunctionalIcon from '../../../assets/img/icons/Risk Summary/Functional.svg';
import PainIcon from '../../../assets/img/icons/Risk Summary/Pain.svg';


const styles = theme => ({
  overlay: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(1)',
    // transform: 'translate(-50%, -50%) scale(0.6)',
    width: '120vw',
    maxWidth: '92%',
    // maxWidth: '1200px',
    height: '98vh',
    maxHeight: '100vh',
    background: '#fff',
    boxShadow: '0 0 20px rgba(0,0,0,0.2)',
    zIndex: 1800,
    padding: theme.spacing(1.5),
    borderRadius: 10,
    overflow: 'auto',        // Enable scroll inside overlay
    fontSize: '1.5rem',
  },
  section: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    background: '#f0fafd',
    borderRadius: 6,
  },
  pinkButton: {
    background: '#ff80aa',
    color: 'white',
    // fontSize: '1.3rem', // Increased from 0.75rem
    fontSize: '0.875rem', // Increased from 0.75rem
    // padding: '8px 16px', // Increased padding
    padding: '4px 16px', // Increased padding
    // marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    '&:hover': {
      background: '#ff4d94'
    }
  },

  card: {
    background: '#fff',
    borderRadius: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    padding: theme.spacing(1),
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  // Title and summary are clamped to a fixed number of lines so every card
  // is exactly the same height and the charts line up. Full text on hover.
  domainTitle: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    lineHeight: 1.4,
    height: '2.8em',
    cursor: 'help',
  },
  domainSummary: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    height: '4.8em',
    marginBottom: theme.spacing(0.5),
    cursor: 'help',
  },
  riskMeter: {
    textAlign: 'center',
    marginBottom: theme.spacing(2.5),
  },
  graphBox: {
    width: '100%',
  },
  iconLabel: {
    display: 'flex',
    // alignItems: 'center',
    gap: 3,
    // fontSize: '1.4rem', // Increased
    fontSize: '14px', // Increased
  },
  dialogPaper: {
    minWidth: '60%',
    maxWidth: '800px',
    maxHeight: '90vh',
  },
  riskMeterContainer: {
    // display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  leftSection: {
    flex: 1,
    '& h5': { // Target h5 specifically
      // fontSize: '1.9rem', // Large heading
      fontSize: '1.25rem', // Large heading
      fontWeight: 'bold',
    }
  },
  centerSection: {
    flex: 1,
    textAlign: 'center',
  },
  rightSection: {
    flex: 1,
    display: 'flex',
    // justifyContent: 'flex-end',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(2),
      color: '#f44336',
      fontSize: '1.3rem', // Increased
    },
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: '1.7rem', // Larger icons
    },
  },
  riskLevel: {
    color: 'red',
    fontWeight: 600,
    marginTop: theme.spacing(0.5),
    // fontSize: '1.7rem', // Increased from 0.8rem
    fontSize: '1.125rem', // Increased from 0.8rem
  },
  summaryHeading: {
    // fontSize: '1.7rem', // Larger heading
    fontSize: '1.125rem', // Larger heading
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  bodyText: {
    // fontSize: '1.4rem', // Increased body text
    fontSize: '14px', // Increased body text
    // fontSize: '1rem', // Increased body text
    lineHeight: '1.6',
  },
  listItem: {
    fontSize: '1rem', // Larger list items
    // fontSize: '1.4rem', // Larger list items
  },
  chartLabel: {
    fontSize: '1.2rem', // Larger chart labels
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    '& svg': {
      fontSize: '2rem', // Larger close icon
    }
  },
  graphContainer: {
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      flexGrow: 0,
      maxWidth: '20%',
      flexBasis: '25%',
    },
  },
});

class OverallRiskPage extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    let spinner = document.getElementById("loadingSpinner");
    this.dateUtility = new DateFnsUtils();

    this.addressStreetInputRef = React.createRef();
    let userInfo = JSON.parse(localStorage.getItem(USER_INFO));
    let sessionPatientList = JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || {};
    let patientId = JSON.parse(localStorage.getItem("_selected_patient_list"));
    let selectedPatients = JSON.parse(
      sessionStorage.getItem(MULTIPLE_PATIENT_LIST)
    );
    let patientInfo = JSON.parse(sessionStorage.getItem("patientInfo"));

    let patientDetail = sessionPatientList.find(patient => String(patient.patientId) === String(selectedPatients));

    console.log("Risk summary  patientId: ", patientId)
    console.log("Risk summary patinetDetails: ", selectedPatients);



    this.state = {
      languageAndInsuranceList: this.props.languageAndInsuranceList,
      hospitalList: this.props.hospitalListRedux
        ? this.props.hospitalListRedux
        : [],
      categoryList: this.props.categoryListRedux,
      patientInfo: patientInfo,
      categoryName: "",
      categoryId: this.props.categoryId,
      selectedCategoryId: this.props.categoryId,

      patientTaskModalStatus: false,
      reduxLoadFlag: false,
      confirmBoxStatus: false,
      readOnly: this.props.readOnly ? this.props.readOnly : false,
      selectedCategoryId: "",
      isInsuranceFiltered: true,
      openTaskModal: false,
      patientDetail: patientDetail,
      patientId: patientId,
      mile: 50,
      longitude: "",
      latitude: "",
      patientList: null,
      patientNotesStatus: false,
      showNotesModal: false,
      aiSummary: [],
      showRiskPage: false,
      spinner: spinner,
      isEditingJustification: false,
      editedJustification: '',

      aiSummaryLlama: [],
      aiSummaryOpenAI: [],
      aiSummaryAnthropic: [],
      aiSummarySonnet: [],   // <-- new one for Sonnet 4.5

      aiSummaryLoaded: false,
      activeModel: "llama",
    }

    this.updatePatientModalClose = this.updatePatientModalClose.bind(this);
    this.loaderStatus = this.loaderStatus.bind(this);
    this.handleCloseNotesModal = this.handleCloseNotesModal.bind(this);
    this.handleSaveJustification = this.handleSaveJustification.bind(this);

  }

  pacificFormatDateString = (dateStr, format = "MM/dd/yyyy") => {
    if (!dateStr) return "";

    let dateObj;

    // Convert input into Date object
    if (dateStr instanceof Date) {
      dateObj = dateStr;
    } else {
      // The backend sends a UTC wall-clock string with NO timezone marker, e.g.
      // "08 Jul 2026 4:00 AM" (see SFLlamaServiceImpl.formatTimestampForUI). A bare
      // new Date(str) parses that non-ISO format in the BROWSER's local zone, and the
      // Pacific conversion below then double-shifts it (the off-by-one-day tooltip bug).
      // Parse the fixed format explicitly as UTC via Date.UTC so the single Pacific
      // conversion is correct in every browser. Fall back to native parsing for
      // ISO/other inputs.
      const m = /^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{4})\s+(\d{1,2}):(\d{2})\s*([AaPp][Mm])?$/.exec(
        String(dateStr).trim()
      );
      if (m) {
        const MONTHS = {
          jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
          jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
        };
        const monthIdx = MONTHS[m[2].toLowerCase()];
        if (monthIdx === undefined) {
          dateObj = new Date(dateStr); // unknown month token — fall back
        } else {
          let hour = Number(m[4]) % 12; // 12 AM -> 0, 12 PM -> 0 (then +12 below)
          if (m[6] && m[6].toUpperCase() === "PM") hour += 12;
          dateObj = new Date(Date.UTC(Number(m[3]), monthIdx, Number(m[1]), hour, Number(m[5])));
        }
      } else {
        // ISO-8601 or other natively-parseable formats
        dateObj = new Date(dateStr);
      }
      if (isNaN(dateObj)) return "";
    }

    // Convert to Pacific Time using Intl.DateTimeFormat
    const pacificFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const [{ value: month }, , { value: day }, , { value: year }] = pacificFormatter.formatToParts(dateObj);

    // Format output
    if (format === "yyyy-MM-dd") return `${year}-${month}-${day}`;
    if (format === "MM/dd/yyyy") return `${month}/${day}/${year}`;
    if (format === "dd/MM/yyyy") return `${day}/${month}/${year}`;

    // Default fallback
    return `${month}/${day}/${year}`;
  };

  loaderStatus = (status) => {
    this.setState({
      loading: status,
    });
  };

  handleOpenPatientNotes = (patientNote) => {
    let sessionPatientList = JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || {};
    const patientId = JSON.parse(localStorage.getItem("_selected_patient_list")); // ← Get from localStorage
    let patientDetail = sessionPatientList.find(patient => String(patient.patientId) === String(patientId));
    let patientInfo = JSON.parse(sessionStorage.getItem("patientInfo"));
    console.log("Risk summary  Notes id: ", patientId)
    console.log("Risk summary patinetInfo: ", patientInfo);
    this.setState({ showNotesModal: true, patientDetail, patientInfo, patientId, patientNote });
  };

  handleCloseNotesModal = () => {
    this.setState({ showNotesModal: false });
  };

  openTaskModal = async (suggestedTaskName) => {
    let sessionPatientList = JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || {};
    const patientId = JSON.parse(localStorage.getItem("_selected_patient_list")); // ← Get from localStorage
    let patientDetail = sessionPatientList.find(patient => String(patient.patientId) === String(patientId));
    this.setState({
      openTaskModal: true,
      //patientTaskId: taskId,
      //patientId:patientId,
      patientDetail: patientDetail,
      suggestedTaskName: suggestedTaskName
    });
  }

  //   handleOpenTask = (taskName) => {
  //   console.log("patientInfo:props", this.props.patientInfo);
  //   console.log("patientInfo:", this.state.patientInfo);
  //   console.log("Opening Notes with justification:", patientNote);
  //   this.setState({ showNotesModal: true, patientId,patientNote });
  // };

  updatePatientModalClose = () => {
    let patientList = JSON.parse(localStorage.getItem(PATIENT_LIST));
    this.setState({
      patientModalStatus: false,
      openTaskModal: false,
      patientItemList: patientList,
    });
  };

  renderSVGGraph(domain) {
    const { classes } = this.props;
    const maxValue = 10;
    const graphWidth = 500;
    const graphHeight = 100;
    const extraHeightForLabels = 60; // more room for rotated labels

    const margin = 30; // horizontal margin for first/last label
    const pointDistance =
      (graphWidth - 2 * margin) / (domain.xaxis.length - 1);

    const data = domain.yaxis.map((value, index) => ({
      name: domain.xaxis[index],
      value: value === null || value === undefined ? null : Number(value),
      //submittedDate: domain.submittedDate[index] || ""
      submittedDate: this.pacificFormatDateString(domain.submittedDate[index] || "")
    }));



    // ✅ For testing: inject static chart data
    // const testXaxis = ["D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "D10"];
    // const testYaxis = [2, 4, 6, 3, 7, 8, 5, 9, 4, 6];

    // // use static data ONLY for rendering (don’t touch aiSummary)
    // const xaxis = testXaxis;
    // const yaxis = testYaxis;

    // const pointDistance = (graphWidth - 2 * margin) / (xaxis.length - 1);

    // const data = yaxis.map((value, index) => ({
    //   name: xaxis[index],
    //   value: value,
    // }));

    const points = data
      .map((d, i) => {
        if (d.value === null || d.value === undefined) return null; // skip only null/undefined
        const x = margin + i * pointDistance;
        const y = graphHeight - (d.value / maxValue) * graphHeight;
        return `${x},${y}`;
      })
      .filter(Boolean)
      .join(" ");


    const colors = {
      "Medication Adherence": "#4f83cc",
      "Functional Status (ADLs)": "#66bb6a",
      "Functional Status": "#66bb6a", // ✅ Added mapping for API response
      "Cognitive Awareness / Confusion": "#fdd835",
      "Cognitive Awareness": "#fdd835", // ✅ Added mapping for API response
      "Pain / Discomfort": "#ef5350",
      "Social Support Availability": "#ab47bc",
    };

    const images = {
      "Medication Adherence": MedicationAdherence,
      "Functional Status (ADLs)": Functional,
      "Functional Status": Functional, // ✅ Added mapping for API response
      "Cognitive Awareness / Confusion": confusion,
      "Cognitive Awareness": confusion, // ✅ Added mapping for API response
      "Pain / Discomfort": PainDiscomfort,
      "Social Support Availability": Social,
    };

    const color = colors[domain.domainName] || "#666";
    const riskLabel = domain.domainRisk || "N/A";
    console.log("riskLabel", riskLabel);

    // let riskColor = "";
    // switch (1) {
    //   case 3:
    //     riskLabel = "High";
    //     riskColor = "red";
    //     break;
    //   case 2:
    //     riskLabel = "Medium";
    //     riskColor = "orange"; // or yellow
    //     break;
    //   case 1:
    //     riskLabel = "Low";
    //     riskColor = "green";
    //     break;
    //   default:
    //     riskLabel = "N/A";
    //     riskColor = "#666";
    // }
    return (
      <Grid
        item
        xs={12}
        md={6}
        lg={3}
        key={domain.domainName}
        className={classes.graphContainer}
      >
        <Card className={classes.card}>
          <Box display="flex" alignItems="center" className={classes.iconLabel}>
            <img
              src={images[domain.domainName]}
              alt={`${domain.domainName} icon`}
              style={{ width: 20, height: 20, marginRight: 8 }}
            />
            <Typography
              variant="subtitle2"
              className={`${classes.iconLabel} ${classes.domainTitle}`}
              title={domain.domainName}
            >
              {domain.domainName}{" "}
              <ArrowUpwardIcon
                fontSize="large"
                style={{ color, width: 20, height: 20 }}
              />
            </Typography>
          </Box>
          <Typography
            variant="body2"
            className={`${classes.bodyText} ${classes.domainSummary}`}
            title={domain.domainSummary}
          >
            {domain.domainSummary}
          </Typography>
          <Box mb={0.5}>
            <span
              style={{
                padding: "2px 10px",
                borderRadius: "999px",
                backgroundColor:
                  domain.domainRisk === "High" ? "red" :
                  domain.domainRisk === "Medium" ? "yellow" :
                  domain.domainRisk === "Low" ? "green" : "gold",
                color:
                  domain.domainRisk === "High" ? "white" :
                  domain.domainRisk === "Medium" ? "black" :
                  domain.domainRisk === "Low" ? "white" : "black",
                fontSize: "11px",
                fontWeight: "600",
                textTransform: "uppercase",
                flexShrink: 0, // ✅ prevents badge from shrinking
              }}
            >
              {domain.domainRisk + " Risk" || "N/A"}
            </span>
          </Box>
          <Box className={classes.graphBox}>
            <svg
              width="100%"
              height="auto"
              viewBox={`0 0 ${graphWidth} ${graphHeight + extraHeightForLabels}`}
              preserveAspectRatio="xMidYMid meet"
              style={{ overflow: "visible", display: "block" }}
            >
              <g transform="translate(0,0)">
                {/* Y-axis */}
                <line
                  x1={margin}
                  y1="0"
                  x2={margin}
                  y2={graphHeight}
                  stroke="#ddd"
                  strokeWidth="1"
                />
                {/* X-axis label */}
                <text
                  x={margin / 2}
                  y={graphHeight / 2}
                  transform={`rotate(-90, ${margin / 2}, ${graphHeight / 2})`}
                  textAnchor="middle"
                  fontSize="16"    // Increased font size
                  fontWeight="bold" // Make text bold
                  fill="black"
                  style={{ dominantBaseline: "middle" }}
                >
                  Risk Score
                </text>

                {/* X-axis */}
                <line
                  x1={margin}
                  y1={graphHeight}
                  x2={graphWidth - margin}
                  y2={graphHeight}
                  stroke="#ddd"
                  strokeWidth="1"
                />

                {/* X-axis label */}
                <text
                  x={graphWidth / 2}
                  y={graphHeight + extraHeightForLabels + 6}  // Reduced space below graph
                  textAnchor="middle"
                  fontSize="16"       // Increased font size
                  fontWeight="bold"   // Make text bold
                  fill="black"
                >
                  Surveys
                </text>

                {/* Line graph */}
                <polyline
                  fill="none"
                  stroke={color}
                  strokeWidth="2"
                  points={points}
                />

                {/* {data.map((d, i) => {
                  const x = margin + i * pointDistance;
                  const y = graphHeight - (d.value / maxValue) * graphHeight;
                  return (
                    <g key={i}>
                      <circle cx={x} cy={y} r="4" fill={color} />
                      <text
                        x={x}
                        y={graphHeight + 25}
                        textAnchor="middle"
                        fontSize="12"
                        fill="#666"
                        fontFamily="Arial"
                        className={classes.chartLabel}
                        transform={`rotate(-30, ${x}, ${graphHeight + 25})`}
                      >
                        {d.name}
                      </text>
                      <text
                        x={x}
                        y={y - 5}
                        textAnchor="middle"
                        fontSize="10"
                        fill={color}
                        fontWeight="bold"
                      >
                        {d.value}
                      </text>
                    </g>
                  );
                  
                })} */}
                {data.map((d, i) => {
                  const x = margin + i * pointDistance;
                  const y = graphHeight - (d.value / maxValue) * graphHeight;

                  const isHovered =
                    (this.state.tooltip && this.state.tooltip.index === i) ||
                    (this.state.selectedPoint && this.state.selectedPoint.index === i);

                  // Tooltip size
                  const tooltipWidth = 250;
                  const tooltipHeight = 70;
                  const offsetX = 15;
                  const offsetY = 60;

                  let tooltipX = x + offsetX;
                  let tooltipY = y - offsetY;

                  if (tooltipX + tooltipWidth > graphWidth) {
                    tooltipX = x - tooltipWidth - offsetX; // shift left
                  }
                  if (tooltipY < 0) {
                    tooltipY = y + offsetY; // shift below if above graph
                  }

                  return (
                    <g
                      key={i}
                      onMouseEnter={() =>
                        this.setState({ tooltip: { x, y, d, index: i } })
                      }
                      onMouseLeave={() => this.setState({ tooltip: null })}
                      onClick={() =>
                        this.setState(prev => ({
                          selectedPoint:
                            prev.selectedPoint && prev.selectedPoint.index === i
                              ? null
                              : { x, y, d, index: i }
                        }))
                      }
                    >
                      {/* ✅ Always show X-axis labels */}
                      <text
                        x={x}
                        y={graphHeight + 25}
                        textAnchor="middle"
                        fontSize="12"
                        fill="#666"
                        fontFamily="Arial"
                        transform={`rotate(-30, ${x}, ${graphHeight + 25})`}
                      >
                        {d.name}
                      </text>

                      {/* ✅ Show dot + value ONLY if > 0 */}
                      {/* ✅ Show dot + value if 0 or > 0 (skip if null/undefined) */}
                      {d.value !== null && d.value !== undefined && (
                        <>
                          <circle cx={x} cy={y} r="6" fill={color} style={{ cursor: "pointer" }} />

                          {/* Only show label if > 0, not for 0 */}
                          {d.value > 0 && (
                            <text
                              x={x}
                              y={y - 5}
                              textAnchor="middle"
                              fontSize="10"
                              fill={color}
                              fontWeight="bold"
                            >
                              {d.value}
                            </text>
                          )}
                        </>
                      )}


                      {/* ✅ Tooltip only on hover, works for 0/null too */}
                      {this.state.tooltip?.index === i && (
                        <g transform={`translate(${tooltipX}, ${tooltipY})`}>
                          <rect
                            width={tooltipWidth}
                            height={tooltipHeight}
                            fill="#01A7A6"
                            rx="8"
                            ry="8"
                            opacity="0.95"
                          />
                          <text x={15} y={28} fontSize="16" fill="#fff" fontWeight="bold">
                            Submitted At:{" "}
                            {d.submittedDate
                              ? this.dateUtility.format(new Date(d.submittedDate), "MM/dd/yyyy")
                              : "-"}
                          </text>
                          <text x={15} y={52} fontSize="16" fill="#fff" fontWeight="bold">
                            Risk Score: {d.value !== null && d.value !== undefined ? d.value : "-"}

                          </text>
                        </g>
                      )}
                    </g>


                  );
                })}



              </g>
            </svg>
          </Box>
        </Card>
      </Grid>
    );
  }



  // async fetchAISummary() {
  //   alert("callsave")
  //   const patientData = localStorage.getItem("_selected_patient_list");
  //   const patientId = patientData ? JSON.parse(patientData) : null;

  //   if (!patientId) {
  //     console.warn("No patient ID found in local storage.");
  //     this.setState({ aiSummary: [], aiSummaryLoaded: true });
  //     return;
  //   }

  //   const apiUrl = `${apiPath.GetAiSummary}?patientId=${patientId}&aiId=${4}`;

  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "GET",
  //       headers: generalAuthTokenHeader(),
  //     });

  //     if (response.status === 401) {
  //       userService.logout();
  //       window.location.reload(true);
  //       return;
  //     }

  //     const data = await response.json();

  //     if (response.ok) {
  //       if (!data || (Array.isArray(data) && data.length === 0)) {
  //         console.info("No AI summary available for this patient.");
  //       }

  //       this.setState({
  //         aiSummary: data || [],
  //         aiSummaryLoaded: true,
  //       });
  //     } else {
  //       console.warn("API response not OK", data);
  //       if (!data || !data.ok) {
  //         console.warn("API response not OK", data);

  //         userService.showNotification({
  //           title: "",
  //           message: "No AI summary available for this patient.",
  //           type: "warning",
  //         });
  //       }

  //       this.setState({ aiSummary: [], aiSummaryLoaded: true });
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //     this.setState({ aiSummary: [], aiSummaryLoaded: true });
  //   }
  // }

  fetchAISummary = async () => {

    const patientData = localStorage.getItem("_selected_patient_list");
    const patientId = patientData ? JSON.parse(patientData) : null;

    if (!patientId) {
      this.setState({ aiSummaryLoaded: true });
      return;
    }

    const apiUrl = `${apiPath.GetAiSummary}?patientId=${patientId}&aiId=${4}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }

      const data = await response.json();

      this.setState({
        aiSummary: data || [],
        aiSummaryLoaded: true,
      });
    } catch (error) {
      console.error("Fetch error:", error);
      this.setState({ aiSummary: [], aiSummaryLoaded: true });
    }
  };

  // componentDidUpdate(prevProps) {
  //   // Check if the dialog just opened
  //   if (!prevProps.open && this.props.open) {
  //     console.log("Dialog just opened!");
  //     console.log("Previous props:", prevProps.open);
  //     console.log("Current props:", this.props.open);
  //     console.log("Active model:", this.state.activeModel);

  //     // Map model to API id and state key
  //     const aiModels = {
  //       llama: { id: 1, key: "aiSummaryLlama" },
  //       openai: { id: 2, key: "aiSummaryOpenAI" },
  //       anthropic: { id: 3, key: "aiSummaryAnthropic" },
  //       sonnet: { id: 4, key: "aiSummarySonnet" },   // ✅ new entry for Sonnet 4.5
  //     };

  //     const { id, key } = aiModels[this.state.activeModel];
  //     console.log("Fetching AI summary for:", key, "with id:", id);

  //     // Fetch summary for current active model
  //     this.fetchAISummary(4, "aiSummarySonnet");
  //   }
  // }
  componentDidUpdate(prevProps) {
    // ✅ Detect when dialog opens
    if (this.props.open && !prevProps.open) {
      this.fetchAISummary();
    }
  }

  getRiskImage(riskLevel) {
    switch (riskLevel?.toLowerCase()) {
      case 'low':
        return Low;
      case 'medium':
        return Medium;
      case 'high':
        return High;
      default:
        return null;
    }
  }

  // ✅ Helper method to get domain icon based on domain name
  getDomainIcon(domainName) {
    const name = domainName?.toLowerCase();
    if (name?.includes('medication') || name?.includes('meds')) {
      return MedsIcon;
    } else if (name?.includes('social')) {
      return SocialSupportIcon;
    } else if (name?.includes('cognition') || name?.includes('cognitive')) {
      return CognitionIcon;
    } else if (name?.includes('functional') || name?.includes('adl')) {
      return FunctionalIcon;
    } else if (name?.includes('pain') || name?.includes('discomfort')) {
      return PainIcon;
    }
    return null;
  }

  // ✅ Helper method to get domain display name
  getDomainDisplayName(domainName) {
    const name = domainName?.toLowerCase();
    if (name?.includes('medication') || name?.includes('meds')) {
      return 'Meds';
    } else if (name?.includes('social')) {
      return 'Social Support';
    } else if (name?.includes('cognition') || name?.includes('cognitive')) {
      return 'Cognition';
    } else if (name?.includes('functional') || name?.includes('adl')) {
      return 'Functional Status';
    } else if (name?.includes('pain') || name?.includes('discomfort')) {
      return 'Pain/Discomfort';
    }
    return domainName;
  }

  // handleRiskSummaryClick = async () => {
  //   try {
  //     await this.fetchAISummary();

  //     const { aiSummary } = this.state;

  //     const hasData =
  //       aiSummary &&
  //       (aiSummary.overallRisk ||
  //         aiSummary.summary ||
  //         aiSummary.detailed ||
  //         (Array.isArray(aiSummary.suggestions) && aiSummary.suggestions.length > 0) ||
  //         (Array.isArray(aiSummary.chart) && aiSummary.chart.length > 0) ||
  //         aiSummary.justification);

  //     if (hasData) {
  //       this.setState({ showRiskPage: true });
  //       // } else {
  //       //   console.warn("No AI summary data found for this patient.");
  //       //   // Optional: notify user
  //       //   userService.showNotification({
  //       //     title: "",
  //       //     message: "No AI summary data available for this patient.",
  //       //     type: "info",
  //       //   });
  //     }
  //   } catch (err) {
  //     console.error("Error in fetchAISummary:", err);
  //     userService.showNotification({
  //       title: "",
  //       message: "Failed to load AI summary.",
  //       type: "error",
  //     });
  //   }
  // };
  //  componentDidUpdate(prevProps) {
  //     // ✅ Detect when dialog opens
  //     if (this.props.open && !prevProps.open) {
  //       this.fetchAISummary();
  //     }
  //   }

  handleRiskSummaryClickClose = () => {
    this.setState({ showRiskPage: false });
  };
  // handleEditJustification = () => {
  //   let aiSummary = null;

  //   if (this.state.activeModel === "llama") {
  //     aiSummary = this.state.aiSummaryLlama;
  //   } else if (this.state.activeModel === "openai") {
  //     aiSummary = this.state.aiSummaryOpenAI;
  //   } else if (this.state.activeModel === "anthropic") {
  //     aiSummary = this.state.aiSummaryAnthropic;
  //   } else if (this.state.activeModel === "sonnet") {
  //     aiSummary = this.state.aiSummarySonnet;
  //   }

  //   this.setState({
  //     isEditingJustification: true,
  //     editedJustification: aiSummary?.justification || ""
  //   });
  // };
  // handleEditJustification = () => {
  //   this.setState({
  //     isEditingJustification: true,
  //     editedJustification: this.state.aiSummary.justification
  //   });
  // };
   handleEditJustification = () => {
  const justification = this.state.aiSummary.justification;

  // If it's an array, join it into a single string
  const combinedJustification = Array.isArray(justification)
    ? justification.join(' ') // you can use '\n' or ', ' instead of ' ' if needed
    : justification;

  this.setState({
    isEditingJustification: true,
    editedJustification: combinedJustification
  });
};
  handleJustificationChange = (value) => {
    this.setState({ editedJustification: value });
  };
  handleSaveJustification = async () => {
    this.state.spinner.removeAttribute("hidden");


    const payload = {
      aiSummaryId: this.state.aiSummary.aiSummaryId,
      justification: this.state.editedJustification,
      aiId: 4   // ✅ Added aiId here
    };

    console.log("payload", payload);

    const apiUrl = apiPath.UpdateJustification;
    let showNotification = {};

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 400) {
        showNotification = { title: "Survey", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Survey", message: "Error submitting survey", type: "danger" };
      } else {
        showNotification = { title: "Survey", message: "Survey updated successfully!", type: "success" };

        // Update the correct aiSummary in state

        this.setState((prevState) => ({
          aiSummary: {
            ...prevState.aiSummary,
            justification: prevState.editedJustification
          },
          isEditingJustification: false,   // <-- Exit editing mode
          modalStatus: false
        }));

        if (this.props.onClose) {
          this.props.onClose();
        }
      }

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error submitting survey", error);
      userService.showNotification({ title: "Survey", message: "Server Error", type: "danger" });
    }

    this.state.spinner.setAttribute("hidden", "true");
  };

  getButtonStyle(model) {
    return {
      whiteSpace: "nowrap",
      alignSelf: "flex-start",
      backgroundColor: this.state.activeModel === model ? "#51c1c0" : "",
      color: this.state.activeModel === model ? "#fff" : "",
    };
  }

  render() {
    const { classes } = this.props;
    const { aiSummary, aiSummaryLoaded } = this.props;

    const hasChartData =
      aiSummary &&
      aiSummary.chart &&
      Array.isArray(aiSummary.chart) &&
      aiSummary.chart.length > 0;

    const hasSuggestions =
      aiSummary &&
      aiSummary.suggestions &&
      Array.isArray(aiSummary.suggestions) &&
      aiSummary.suggestions.length > 0;

    const hasJustifications =
      aiSummary &&
      aiSummary.justification &&
      Array.isArray(aiSummary.justification) &&
      aiSummary.justification.length > 0;


    // if (!aiSummaryLoaded) {
    //   return (
    //     <Box className={classes.overlay}>
    //       <Typography className={classes.bodyText}>Loading AI Summary...</Typography>
    //     </Box>
    //   );
    // }

    // if (!aiSummary || (Array.isArray(aiSummary) && aiSummary.length === 0)) {
    //   return (
    //     <Box className={classes.overlay}>
    //       <Button className={classes.closeButton} onClick={this.props.onClose}>
    //         <CloseIcon />
    //       </Button>

    //       <Typography variant="h6" className={classes.summaryHeading}>No risk assessment data available</Typography>
    //       {/* <Typography variant="body2" className={classes.bodyText}>
    //         We couldn't generate a risk assessment for this patient.
    //       </Typography> */}
    //     </Box>
    //   );
    // }

    // const hasChartData = aiSummary.chart && Array.isArray(aiSummary.chart) && aiSummary.chart.length > 0;
    // const hasSuggestions = aiSummary.suggestions && Array.isArray(aiSummary.suggestions) && aiSummary.suggestions.length > 0;

    return (
      <div style={{ marginLeft: 19 }} className='riskbtn'>
        {/* <Button className="pointer btn1 height50" onClick={this.handleRiskSummaryClick}>
          <img src={riskIcon} alt="" srcset="" style={{ paddingRight: 10 }}/>
          Risk Summary
        </Button> */}
        <Dialog open={this.props.open} onClose={this.handleRiskSummaryClickClose} fullWidth maxWidth="md">
          <DialogContent className={classes.overlay}>
            <Button className={classes.closeButton} onClick={this.props.onClose}>
              <CloseIcon />
            </Button>

            <Box>
              {/* <Button
                className={classes.pinkButton}
                size="large"
                style={{
                  backgroundColor: this.state.activeModel === "llama" ? "#51c1c0" : "",
                  color: this.state.activeModel === "llama" ? "#fff" : "",
                }}
                onClick={() => this.fetchAISummary(1, "aiSummaryLlama")}

              >
                Llama
              </Button>

              <Button
                className={classes.pinkButton}
                size="large"
                style={{
                  backgroundColor: this.state.activeModel === "openai" ? "#51c1c0" : "",
                  color: this.state.activeModel === "openai" ? "#fff" : "",
                }}
                onClick={() => this.fetchAISummary(2, "aiSummaryOpenAI")}
              >
                OpenAI
              </Button>

              <Button
                className={classes.pinkButton}
                size="large"
                style={{
                  backgroundColor: this.state.activeModel === "anthropic" ? "#51c1c0" : "",
                  color: this.state.activeModel === "anthropic" ? "#fff" : "",
                }}
                onClick={() => this.fetchAISummary(3, "aiSummaryAnthropic")}
              >
                Anthropic
              </Button>
              <Button
                className={classes.pinkButton}
                size="large"
                style={{
                  backgroundColor: this.state.activeModel === "sonnet" ? "#51c1c0" : "",
                  color: this.state.activeModel === "sonnet" ? "#fff" : "",
                }}
                onClick={ () => this.fetchAISummary(4, "aiSummarySonnet")}
              >
                Sonnet 4.5
              </Button>
 */}





              {aiSummary?.overallRisk && (
                <React.Fragment>
                <Box
                  className={classes.riskMeterContainer}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {/* LEFT SECTION */}
                  <Box className={classes.leftSection}>
                    <Typography variant="h5">OVERALL RISK</Typography>
                    <Typography>
                      <Box component="span" fontWeight="bold">Patient Name:</Box>{" "}
                      {this.props.patientLastName} {this.props.patientFirstName} {this.props.patientMiddleName}
                    </Typography>
                  </Box>

                  {/* CENTER SECTION - always stays centered */}
                  <Box
                    className={classes.centerSection}
                    sx={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={this.getRiskImage(aiSummary.overallRisk)}
                      alt="Risk Meter"
                      style={{ height: 70 }}
                    />
                  </Box>

                  {/* RIGHT SECTION - always rendered, content conditionally shown */}
                  <Box
                    className={classes.rightSection}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      minWidth: '280px', // ✅ reserve width to prevent shifting
                    }}
                  >
                    {/* ✅ Filter and display icons for domains with High risk */}
                    {aiSummary?.chart && Array.isArray(aiSummary.chart) &&
                      aiSummary.chart
                        .filter(domain => domain.domainRisk?.toLowerCase() === 'high')
                        .map((domain, index) => {
                          const icon = this.getDomainIcon(domain.domainName);
                          const displayName = this.getDomainDisplayName(domain.domainName);

                          if (!icon) return null; // Skip if no matching icon

                          return (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              ml={3}
                              color="#f44336"
                            >
                              <img
                                src={icon}
                                alt={displayName}
                                style={{ width: 24, height: 24, marginRight: 8 }}
                              />
                              <Typography variant="body2" className={classes.bodyText}>
                                {displayName}
                              </Typography>
                            </Box>
                          );
                        })
                    }
                  </Box>
                </Box>
                </React.Fragment>
              )}


              {aiSummary?.summary && (
                <Box className={classes.section}>
                  <Box display="flex" alignItems="center">
                    <img src={Summary} alt="Summary Icon" style={{ width: 20, height: 20, marginRight: 8, marginTop: -10 }} />
                    <Typography variant="h6" className={classes.summaryHeading}>
                      Summary
                    </Typography>
                    {/* Persistent non-clinical disclaimer — same wording as the facility risk email. */}
                    <Typography
                      style={{
                        flex: 1,
                        marginLeft: 12,
                        fontStyle: 'italic',
                        color: '#555',
                        fontSize: '0.75rem',
                        lineHeight: 1.3,
                      }}
                    >
                      Informational check-in signals that support your team's judgment — not clinical alerts, not real-time, and never requiring action on any timetable. (Patients are directed to 911/988 for emergencies.)
                    </Typography>
                  </Box>
                  <Typography variant="body2" className={classes.bodyText}>

                    <div >
                      <ul style={{ listStyleType: "disc", paddingLeft: "10px", marginTop: "5px" }}>
                        <li>
                          <strong>Confidence Score: </strong>
                          {aiSummary.confidenceScore ? aiSummary.confidenceScore : "N/A"}
                        </li>
                      </ul>
                    </div>
                    {aiSummary.summary}
                  </Typography>
                </Box>
              )}

              {hasChartData && (
                <Grid container spacing={2}>
                  {aiSummary?.chart.map(domain => this.renderSVGGraph(domain))}
                </Grid>
              )}

              {aiSummary?.detailed && (
                <Box className={classes.section}>
                  <Box display="flex" alignItems="center">
                    <img src={Detailed} alt="Summary Icon" style={{ width: 20, height: 20, marginRight: 8, marginTop: -10 }} />
                    <Typography variant="h6" className={classes.summaryHeading}>AI Analysis </Typography>
                  </Box>
                  <Box sx={{
                    display: {
                      xs: 'block', // mobile (default)
                      lg: 'flex',  // desktop and above
                    },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                    <Typography variant="body2" className={classes.bodyText}>

                      <div>
                        <ul style={{ listStyleType: "disc", paddingLeft: "10px", marginTop: "5px" }}>
                          <li><strong>Proactive Watchlist:</strong> {
                            (() => {
                              const watchlist = aiSummary.proactiveWatchlist;
                              // Handle old boolean format
                              if (typeof watchlist === 'boolean') {
                                return watchlist ? "Yes" : "No";
                              }
                              // Handle new string format
                              if (typeof watchlist === 'string' && watchlist.trim() !== "") {
                                return watchlist;
                              }
                              return "No proactive monitoring required";
                            })()
                          }</li>
                          <li><strong>Risk Velocity:</strong> {aiSummary.riskVelocity ? aiSummary.riskVelocity : 'N/A'}</li>
                          <li><strong>Readmission Summary:</strong> {aiSummary.readmissionSummary ? aiSummary.readmissionSummary : 'N/A'}</li>
                          <li><strong>Recapture Summary:</strong> {aiSummary.recaptureSummary ? aiSummary.recaptureSummary : 'N/A'}</li>
                          <li><strong>Recapture Opportunity:</strong></li>
                          ➤ <strong>Eligible:</strong> {aiSummary.recaptureOpportunity ?
                            aiSummary.recaptureOpportunity.eligible : 'N/A'}
                          <br />
                          ➤ <strong>Reasoning:</strong>  {aiSummary.recaptureOpportunity ?
                            aiSummary.recaptureOpportunity.reasoning : 'N/A'}
                        </ul>
                      </div>
                      {aiSummary.detailed}
                    </Typography>
                    {/* <Button className={classes.pinkButton} style={{ width: '370px' }}>Provider Feedback</Button> */}
                  </Box>
                </Box>
              )}

              {hasSuggestions && (
                <Box className={classes.section}>
                  <Box display="flex" alignItems="center">
                    <img src={Suggestions} alt="Summary Icon" style={{ width: 20, height: 20, marginRight: 8, marginTop: -10 }} />
                    <Typography variant="h6" className={classes.summaryHeading}>Suggestions <Button
                      className={classes.pinkButton}
                      size="large" // Changed from small to large
                      style={{ whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
                      onClick={(e) => this.openTaskModal()}
                    >
                      Add Task
                    </Button></Typography>
                  </Box>
                  <Typography variant="body2" className={classes.bodyText}>
                    <ul style={{ paddingLeft: '20px' }}>
                      {aiSummary?.suggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          style={{
                            display: 'flex',
                            // justifyContent: 'space-between',
                            // alignItems: 'flex-start',
                            alignItems: 'center',
                            // marginBottom: '10px',
                            gap: '10px'
                          }}
                          sx={{ display: { sm: "block", xl: "flex" } }}>
                          <span style={{ flex: 1 }}>{suggestion}</span>
                          <Button
                            className={classes.pinkButton}
                            size="large" // Changed from small to large
                            style={{ whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
                            onClick={(e) => this.openTaskModal(suggestion)}
                          >
                            Create Task
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </Typography>
                </Box>
              )}


              <Box className={classes.section}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <img src={Justification} alt="Summary Icon" style={{ width: 20, height: 20, marginRight: 8, marginTop: -10 }} />
                    {/* <Typography variant="h6" className={classes.summaryHeading}>Review Documentation
                      <Box mt={1}>
                        <Button
                          className={classes.pinkButton}
                          onClick={() => this.handleOpenPatientNotes(aiSummary.justification)}
                        >
                          Create Notes
                        </Button>
                      </Box></Typography> */}

                       <Typography variant="h6" className={classes.summaryHeading}>Review Documentation <Button
                      className={classes.pinkButton}
                      size="large" // Changed from small to large
                      style={{ whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
                     onClick={() => this.handleOpenPatientNotes(aiSummary.justification)}
                    >
                       Create Notes
                    </Button></Typography>
                  </Box>
                </Box>

                {/* <Box display={{ xs: 'block', lg: 'flex' }} alignItems="center" justifyContent={'space-between'}>
                  {this.state.isEditingJustification ? (
                    <>
                      <TextField
                        value={this.state.editedJustification}
                        onChange={(e) => this.handleJustificationChange(e.target.value)}
                        fullWidth
                        multiline
                        variant="outlined"
                      />
                      <Box>
                        <IconButton onClick={this.handleSaveJustification}>
                          <Save />
                        </IconButton>
                        <IconButton onClick={() => this.setState({ isEditingJustification: false })}>
                          <Close />
                        </IconButton>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Typography variant="body2" className={classes.bodyText}>
                        {aiSummary?.justification}
                        <IconButton onClick={this.handleEditJustification} size="small">
                          <Edit fontSize="small" />
                        </IconButton>
                      </Typography>
                      <Button
                        className={classes.pinkButton}
                        onClick={() => this.handleOpenPatientNotes(aiSummary.justification)}
                      >
                        Create Notes
                      </Button>
                    </>
                  )}
                </Box> */}

                <Box
                  display={{ xs: 'block', lg: 'flex' }}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  {this.state.isEditingJustification ? (
                    <>
                      <TextField
                        value={this.state.editedJustification}
                        onChange={(e) => this.handleJustificationChange(e.target.value)}
                        fullWidth
                        multiline
                        variant="outlined"
                      />
                      <Box mt={1}>
                        <IconButton onClick={this.handleSaveJustification}>
                          <Save />
                        </IconButton>
                        <IconButton onClick={() => this.setState({ isEditingJustification: false })}>
                          <Close />
                        </IconButton>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                      >
                        <Typography variant="body2" className={classes.bodyText}>
                          <ul style={{ paddingLeft: '20px' }}>
                            {hasJustifications ? (
                              aiSummary.justification.map((item, index) => (
                                <li
                                  key={index}
                                  style={{
                                    display: 'flex',
                                    // justifyContent: 'space-between',
                                    // alignItems: 'flex-start',
                                    alignItems: 'center',
                                    // marginBottom: '10px',
                                    gap: '10px'
                                  }}
                                  sx={{ display: { sm: "block", xl: "flex" } }}>
                                  <span style={{ flex: 1 }}>{item}</span>
                                </li>
                              ))
                            ) : (
                              <span>No justification available</span>
                            )}
                          </ul>
                        </Typography>

                        {/* Edit button on same line */}
                        <IconButton onClick={this.handleEditJustification} size="small">
                          <Edit fontSize="small" />
                        </IconButton>
                      </Box>

                    </>
                  )}
                </Box>

              </Box>


              {/* {hasChartData ? (
                <Grid container spacing={2}>
                  {aiSummary.chart.map(domain => this.renderSVGGraph(domain))}
                </Grid>
              ) : (
                <Box className={classes.section}>
                  <Typography variant="h6" className={classes.summaryHeading}>� Risk Factors</Typography>
                  <Typography variant="body2" className={classes.bodyText}>No risk factor data available</Typography>
                </Box>
              )} */}

              <PatientTasks
                openTaskModal={this.state.openTaskModal}
                updatePatientModalClose={this.updatePatientModalClose}
                patientCategoryList={this.state.patientCategoryList}
                patientDetail={this.state.patientDetail}
                loaderStatus={this.loaderStatus}
                patientTaskId={this.state.patientTaskId}
                suggestedTaskName={this.state.suggestedTaskName}
              />

              <PatientNotesRiskClass
                modalStatus={this.state.showNotesModal}
                selectCategoryId={this.state.categoryId}
                patientInfo={this.state.patientInfo}
                patientId={this.state.patientId}
                onClose={this.handleCloseNotesModal}
                patientNote={this.state.patientNote}
                patientDetail={this.state.patientDetail}
              />
            </Box>
          </DialogContent>
        </Dialog>
      </div >
    );
  }
}

export default withStyles(styles)(OverallRiskPage);